import { GithubIcon, LinkedInIcon, StravaIcon } from '../components/icons'

export const socialLinks = [
  { label: 'GitHub', url: 'https://github.com/blakemulnix', Icon: GithubIcon },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/blakemulnix/',
    Icon: LinkedInIcon,
  },
  {
    label: 'Strava',
    url: 'https://www.strava.com/athletes/106168101',
    Icon: StravaIcon,
  },
] as const
